/* ─── ProgressBar ─── */

import { formatTextual } from '../textual';

/** Max total for rendering discrete step indicators. */
const MAX_DETENTS = 30;

export function ArtifactProgressBar({
  value = 0,
  label,
}: {
  value?: number | [number, number];
  label?: unknown;
}) {
  const isDiscrete = Array.isArray(value);
  const current = isDiscrete ? value[0] : 0;
  const total = isDiscrete ? value[1] : 0;
  const fraction = isDiscrete
    ? total > 0 ? current / total : 0
    : Math.max(0, Math.min(1, value as number));
  const pct = Math.round(fraction * 100);

  const statusText = isDiscrete ? `${current} / ${total}` : `${pct}%`;
  const showDetents = isDiscrete && total > 0 && total <= MAX_DETENTS;

  return (
    <div className="a-progress">
      {label != null && (
        <div className="a-progress-header">
          <span className="a-progress-label">{formatTextual(label)}</span>
          <span className="a-progress-status">{statusText}</span>
        </div>
      )}
      {showDetents ? (
        <div className="a-progress-detents">
          {Array.from({ length: total }, (_, i) => (
            <div
              key={i}
              className={`a-progress-detent ${i < current ? 'a-progress-detent-filled' : ''}`}
            />
          ))}
        </div>
      ) : (
        <div className="a-progress-track">
          <div
            className="a-progress-fill"
            style={{ width: `${pct}%` }}
          />
        </div>
      )}
      {label == null && (
        <div className="a-progress-status" style={{ textAlign: 'right' }}>
          {statusText}
        </div>
      )}
    </div>
  );
}
